import React from 'react'
export default ({
    width = 32,
    height = 32,
    color = "#666",
    className = "icon"
})=>(<svg className={className}  viewBox="0 0 1024 1024" version="1.1" 
xmlns="http://www.w3.org/2000/svg" p-id="5332" width={width} height={height}>
    <path fill={color} d="M277.3 348.4c11.4 16.3 33.8 20.3 50.1 8.9L476 253.5v506.2c0 19.9 16.1 36 36 36s36-16.1 36-36V255l149 103.2c16.5 11.4 38.9 7.5 50-8.8 11.1-16.3 6.8-38.7-9.7-50.1L531.8 156.9c-0.3-0.2-0.5-0.3-0.8-0.5-12.1-8.6-28.7-9.1-41.5-0.2L286.2 298.3c-16.3 11.4-20.2 33.8-8.9 50.1z" p-id="5333"></path><path d="M924 640c-19.9 0-36 16.1-36 36v189.3c0 12.6-6.7 22.7-15 22.7H151c-8.3 0-15-10.2-15-22.7V676c0-19.9-16.1-36-36-36s-36 16.1-36 36v197c0 48 39 87 87 87h722c48 0 87-39 87-87V676c0-19.9-16.1-36-36-36z" p-id="5334"></path></svg>)
